// The account's plan: Premium until, whether it renews, and cancelling the renewals. In Profile and Subscribe.
import { useTranslation } from 'react-i18next';
import { openSubscribe, useCancelAutoRenew, type Billing } from './billing';
import styles from '@/auth/ProfileDialog.module.css';
import own from './SubscribeDialog.module.css';

export function PlanStatus({
  billing,
  offerSubscribe = false,
}: {
  billing: Billing;
  offerSubscribe?: boolean;
}) {
  const { t } = useTranslation();
  const cancel = useCancelAutoRenew();
  const until = billing.premiumUntil ? new Date(billing.premiumUntil).toLocaleDateString() : undefined;

  const cancelRenewals = () => {
    if (window.confirm(t('subscribe.cancelConfirm', { date: until ?? '' }))) cancel.mutate();
  };

  return (
    <div className={own.status}>
      <p className={own.note}>
        {!billing.premium
          ? t('subscribe.status.free')
          : billing.autoRenew
            ? t('subscribe.status.renews', { plan: billing.planName || billing.planTitle, date: until ?? '' })
            : until
              ? t('subscribe.status.until', { date: until })
              : t('subscribe.status.premium')}
      </p>
      {cancel.isError && (
        <p role="alert" className={styles.error}>
          {t('subscribe.cancelError')}
        </p>
      )}
      <div className={styles.actions}>
        {billing.autoRenew && (
          <button
            type="button"
            className={styles.button}
            disabled={cancel.isPending}
            onClick={cancelRenewals}
          >
            {cancel.isPending ? t('subscribe.cancelling') : t('subscribe.cancel')}
          </button>
        )}
        {offerSubscribe && !billing.autoRenew && (
          <button type="button" className={styles.primary} onClick={() => openSubscribe()}>
            {t('nav.subscribe')}
          </button>
        )}
      </div>
    </div>
  );
}
